import { Box } from '@cad-arc';

export function TabCard(props: { children: React.ReactNode }): React.ReactElement {
    return (
        <Box w="100%" borderRadius="base" bg="surface.foreground" p={2}>
            {props.children}
        </Box>
    );
}
